import { type AggRequest, fetchAgg } from '../../../../common/utils/fetch-agg';

import {
	mutateOperationName,
	operationName,
	quickFindMutateZeroQueriesMutation,
	quickFindZeroQueriesQuery,
} from './query';
import {
	type MutateZeroQueriesMutationType,
	type MutateZeroQueriesMutationVariables,
	type QuickFindZeroQueriesQueryType,
	type QuickFindZeroQueriesQueryVariables,
} from './types';

export type QuickFindZeroQueriesQueryProps = Pick<
	AggRequest<QuickFindZeroQueriesQueryVariables>,
	'aggAbsoluteUrl' | 'variables'
>;

export const zeroQueriesQuery = ({ variables, aggAbsoluteUrl }: QuickFindZeroQueriesQueryProps) => {
	return fetchAgg<QuickFindZeroQueriesQueryVariables, QuickFindZeroQueriesQueryType>({
		aggAbsoluteUrl,
		graphQuery: quickFindZeroQueriesQuery,
		variables,
		operationName,
	});
};

export type QuickFindZeroQueriesMutationProps = Pick<
	AggRequest<MutateZeroQueriesMutationVariables>,
	'aggAbsoluteUrl' | 'variables'
>;

export const zeroQueriesMutation = ({
	variables,
	aggAbsoluteUrl,
}: QuickFindZeroQueriesMutationProps) => {
	return fetchAgg<MutateZeroQueriesMutationVariables, MutateZeroQueriesMutationType>({
		aggAbsoluteUrl,
		graphQuery: quickFindMutateZeroQueriesMutation,
		variables,
		operationName: mutateOperationName,
	});
};
